import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';
import jwt from 'jsonwebtoken';

const tokenGenerator = (type) => {
  const cookies = new Cookies();

  const publicToken = jwt.sign(
    {
      type: 'public_user'
    },
    process.env.REACT_APP_SECRET_KEY,
    {
      expiresIn: '24h'
    }
  );

  try {
    // const encryptedData = localStorage.getItem('token');
    const encryptedData = cookies.get('token');

    let token = '';
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      token = decryptedData ? `Bearer ${decryptedData}` : '';

      if (type === 'plain') {
        token = decryptedData;
      }
    } else {
      token = `Bearer ${publicToken}`;
    }
    return token;
  } catch (error) {
    return null;
  }
};

export default tokenGenerator;
